module.exports = __webpack_public_path__ + "img/1Bz_IUqZX6RL6-yIUcyVxyaD7XdAPrQ4r.10ef53e1.png";